export const GET_CAFES = 'cafes/GET_CAFES';
export const GET_CAFES_SUCCESS = 'cafes/GET_CAFES_SUCCESS';
export const GET_CAFES_FAILED = 'cafes/GET_CAFES_FAILED';
